import type { RouteObject } from "react-router";
import { createElement } from "react";
import "./expert.css";
import { QueuePage } from "./QueuePage";
import { WorkbenchPage } from "./WorkbenchPage";
import { MyProgressPage } from "./MyProgressPage";
import { RereviewPage } from "./RereviewPage";

/**
 * docs/UX.md 6–8 + `/a/rereview` (docs/ROADMAP.md A4).
 * Mounted by `router.tsx` behind `RequireRole annotator`.
 */
export const routes: RouteObject[] = [
  { path: "/a", element: createElement(QueuePage) },
  { path: "/a/work/:recordingId", element: createElement(WorkbenchPage) },
  { path: "/a/rereview", element: createElement(RereviewPage) },
  { path: "/a/me", element: createElement(MyProgressPage) },
];

export { QueuePage, WorkbenchPage, MyProgressPage, RereviewPage };
export { AudioPanel } from "./components/AudioPanel";
/** 课程团队 黄金题录入 — the admin screens mount this where they need it. */
export { GoldenSheet } from "./components/GoldenSheet";
export type { GoldenSheetProps } from "./components/GoldenSheet";
export { workHref } from "./QueuePage";
